export interface IdentifiableListItem {
  itemType: string
  id: number | bigint | string
  /**
   * @deprecated Legacy separate global identity field. Backends are migrating to emitting the
   * GraphQL global ID directly as `id` (a string) and will stop sending `globalId`. Kept here
   * only so this helper can bridge payloads mid-rollout.
   */
  globalId?: string
}

/**
 * Collision-free row identity for mixed issue/PR dashboard lists. Prefers a string `id` — the
 * GraphQL global ID, once backends emit it directly as `id` — then falls back to the legacy
 * `globalId` field, then to the composite `${itemType}-${id}`, which is itself collision-safe
 * across the issue/PR id spaces. The composite fallback also covers backend deploy skew where a
 * payload might transiently omit both `id`-as-string and `globalId`.
 */
export function getListItemIdentity(item: IdentifiableListItem): string {
  if (typeof item.id === 'string') return item.id
  return item.globalId ?? `${item.itemType}-${item.id}`
}
